import { createContext } from "react";

interface IFormContext {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    registerField: <TValue = any>(name: string, initialValue: TValue) => void;
    unRegisterField: (name: string) => void;
}

export const formContext = createContext<IFormContext>({} as IFormContext);
